import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function SlideClosing() {
  return <div className="h-full w-full bg-[#1A1A2E] text-white flex flex-col items-center justify-center p-12 relative overflow-hidden" data-id="element-316">
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-[#E60012]/10 to-transparent pointer-events-none" data-id="element-317" />

      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#E60012]/10 pointer-events-none" style={{
      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
    }} data-id="element-318" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-[#C5000F]/10 pointer-events-none" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 0 0)'
    }} data-id="element-319" />

      <motion.div className="z-10 text-center max-w-4xl" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} data-id="element-320">
        <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-321">
          Ready to activate CSL at your next congress?
        </h2>

        <motion.div className="inline-block mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-322">
          <div className="text-2xl font-light tracking-widest uppercase border-b border-[#E60012] pb-2 mb-2" data-id="element-323">
            Snakker™
          </div>
        </motion.div>

        <motion.button className="group flex items-center gap-3 mx-auto text-xl font-medium text-[#E60012] hover:text-white transition-colors duration-300" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} whileHover={{
        x: 5
      }} data-id="element-324">
          Let's talk
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-325" />
        </motion.button>
      </motion.div>
    </div>;
}